<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Словари</strong>
                </CCardHeader>
                <CCardBody>
                    <GrocerTabLinks />
                    <CRow class="pl-3 pb-3" />

                    <CForm>

                        <CTabs
                            variant="pills"
                            :active-tab="0"
                        >

                            <CTab title="Пуши для клиентов" class="pt-1">
                                <Pushes
                                    :entity="entity"
                                    :type="'grocer'"
                                    @save="save"
                                    @goBack="goBack"
                                />
                            </CTab>

                        </CTabs>
                    </CForm>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import GrocerTabLinks from '@/components/grocers/GrocerTabLinks';
    import Pushes from '@/components/dictionaries/Pushes';

    export default {

        name: 'EntityDictionary',
        components: {
            GrocerTabLinks,
            Pushes,
        },

        data: () => ({
            entity: {}
        }),

        computed: {},

        async mounted() {
            const id = this.$route.params.id;
            this.entity = (await this.axios.get(`/grocers/${id}`)).data;
        },

        methods: {
            async save(pushes) {
                try {
                    await this.axios.post(`/grocers/${this.entity.id}/dictionary/pushes`, pushes);
                    this.$router
                        .push({ path: `/grocers/${this.$route.params.id}` });
                } catch (error) {
                    this.$root.$emit('showError', 'Ошибка сохранения.');
                }
            },
            goBack() {
                this.$router
                    .push({ path: `/grocers/${this.$route.params.id}` });
            },
        },
    };
</script>
